// This file is automatically generated. Do not edit it directly.
import { createMiddleware } from '@tanstack/react-start'

// Must be registered as a global `functionMiddleware` in `src/start.ts`; otherwise
// the browser never attaches the bearer token to serverFn RPCs.
// Supabase is loaded on the first server function call so the homepage does not
// download the client (auth, realtime, storage) during first paint.
export const attachSupabaseAuth = createMiddleware({ type: 'function' }).client(
  async ({ next }) => {
    const { supabase } = await import('./client')
    const { data } = await supabase.auth.getSession()
    const token = data.session?.access_token
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
  },
)
